/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 12/10/2019
 *
 * @setPageHeaderData - set the header
 *      page: component
 *      pageName: page Name
 *      pageLink: page link
 *      optionalIcons: optional icon names
 *
 * @saveFormData - save data for the currently loaded form
 * @displayDeleteFormDataWarning - display warning msg for the currently loaded form
 * @deleteFormData - delete data for the currently loaded form
 * @navigateToPreviousPage - navigate to previous page
 * @clearForm - clear the form
 *
 * @openWarningModel - open warning
 * @warningModelData - data in the warning model
 *
 * @openTableColumnViewer - open table column select model
 * @tableColumnViewerData - table column model data
 *
 * @openUrlViewer - open URL viewer
 * @urlViewerData - URL
 *
 * @setAlert - set alert
 *
 * @setLoader - set loader
 *
 * @type {{listenerCount: (function(*): number), rawListeners: (function(*): *), listeners: {}, emit: EventEmitter.emit, off: EventEmitter.off, on: (function(*, *=): EventEmitter)}}
 */
const EventEmitter = {
    listeners: {},
    on: function (eventName, fn) {
        this.listeners[eventName] = this.listeners[eventName] || [];
        this.listeners[eventName].push(fn);
        return this;
    },
    off: function (eventName, fn) {
        let lis = this.listeners[eventName];
        if (!lis) return this;

        Object.keys(lis).forEach((key, i) => {
            if (lis[key] === fn) {
                lis.splice(i, 1);
                return;
            }
        });
        return this;
    },
    emit: function (eventName, ...args) {
        let fns = this.listeners[eventName];
        if (!fns) return false;
        fns.forEach((f) => {
            f(...args);
        });
        return true;
    },
    listenerCount: function(eventName) {
        let fns = this.listeners[eventName] || [];
        return fns.length;
    },
    rawListeners: function(eventName) {
        return this.listeners[eventName];
    }
};

export default EventEmitter;
